export type BillingFrequency =
  | 'IMMEDIATE'
  | 'DAILY'
  | 'WEEKLY'
  | 'MONTHLY'
  | 'ANNUALLY';
export type BillingTiming = 'IN_ADVANCE' | 'IN_ARREARS';
export type BillTo = 'WATER_SUPPLIER' | 'TESTER';

export type ProductType =
  | 'BACKFLOW_ACTIVE_ASSEMBLY'
  | 'BACKFLOW_TEST_PASSED'
  | 'BACKFLOW_TEST'
  | 'BACKFLOW_NOTICE_CREATED'
  | 'BACKFLOW_NOTICE_MAILED';
// | 'SUBSCRIPTION';

export const productTypeLabels: Record<ProductType, string> = {
  BACKFLOW_ACTIVE_ASSEMBLY: 'Active Assembly',
  BACKFLOW_TEST_PASSED: 'Test Report - Passing',
  BACKFLOW_TEST: 'Test Report',
  BACKFLOW_NOTICE_CREATED: 'Notice Created',
  BACKFLOW_NOTICE_MAILED: 'Notice Mailed',
  // SUBSCRIPTION: 'Subscription',
};

export interface PlatformProductInput {
  __typename?: string;
  id?: string | null;
  type: ProductType;
  price: number;
  billingFrequency: BillingFrequency;
  billingTiming: BillingTiming;
  billTo: BillTo;
}

export interface PlatformProduct extends Omit<PlatformProductInput, 'id'> {
  id: string;
}
